// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#em-labels {
    text-anchor: middle;
    stroke-linejoin: round;
    stroke-linecap: round;
    font-family: Arial, Helvetica, sans-serif;
    dominant-baseline: central;
    pointer-events: none;
    paint-order: stroke fill;
}

.em-labels {
    font-size: 12px;
    fill: #000000;
}

.em-label {
    font-size: 12px;
    opacity: 0.9;
}

.em-label-shadow,
.em-flow-label-shadow {
    font-size: 12px;
    stroke-width: 2px;
    stroke: white;
    opacity: 0.9;
    fill: none;
}

.em-label-background {
    fill: #ffffff;
    opacity: 0.9;
}

.em-stat-label {
    fill: #111111;
    stroke: #111111;
    stroke-width: 0.5px;
}

.em-stat-label-shadow {
    fill: none;
    stroke: white;
    stroke-width: 2.5px;
    opacity: 0.9;
}

.em-stat-label,
.em-stat-label-shadow {
    font-size: 13px;
}

.em-label-cc {
    font-size: 12px;
}

.em-label-shadow-cc {
    font-size: 12px;
    stroke-width: 3px;
}

.em-label-countries {
    fill: #111111;
    font-size: 10px;
}

.em-label-shadow-countries {
    font-size: 10px;
    stroke-width: 3px;
}

.em-label-seas {
    font-size: 9px;
    fill: #2a58b3;
    letter-spacing: 0.25em;
    opacity: 0.7;
}

.em-label-shadow-seas {
    font-size: 9px;
    letter-spacing: 0.25em;
    stroke-width: 3px;
    opacity: 0.5;
}

.em-flow-labels {
    text-anchor: middle;
    stroke-linejoin: round;
    font-family: Arial, Helvetica, sans-serif;
    dominant-baseline: central;
}

.em-flow-label {
    font-size: 13px;
    fill: #333333;
    font-weight: bold;
    opacity: 0.9;
}

.em-flow-label-shadow {
    font-size: 13px;
    stroke-width: 3px;
}

.em-circle-stat-label,
.em-circle-stat-label-shadow {
    text-anchor: middle;
    stroke-linejoin: round;
    stroke-linecap: round;
    font-family: Arial, Helvetica, sans-serif;
    dominant-baseline: central;
    pointer-events: none;
    paint-order: stroke fill;
}

.em-circle-code-label,
.em-circle-code-label-shadow {
    text-anchor: middle;
    stroke-linejoin: round;
    stroke-linecap: round;
    font-family: Arial, Helvetica, sans-serif;
    dominant-baseline: central;
    pointer-events: none;
    paint-order: stroke fill;
}

/* labels that overflow outside the proportional symbol */
/* .em-stat-overflowing,
.em-code-overflowing {
    opacity: 0.75;
} */
`, "",{"version":3,"sources":["webpack://./src/css/labels.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,yCAAyC;IACzC,0BAA0B;IAC1B,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,yCAAyC;IACzC,0BAA0B;IAC1B,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;;IAEI,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,yCAAyC;IACzC,0BAA0B;IAC1B,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA,yDAAyD;AACzD;;;GAGG","sourcesContent":["#em-labels {\r\n    text-anchor: middle;\r\n    stroke-linejoin: round;\r\n    stroke-linecap: round;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    dominant-baseline: central;\r\n    pointer-events: none;\r\n    paint-order: stroke fill;\r\n}\r\n\r\n.em-labels {\r\n    font-size: 12px;\r\n    fill: #000000;\r\n}\r\n\r\n.em-label {\r\n    font-size: 12px;\r\n    opacity: 0.9;\r\n}\r\n\r\n.em-label-shadow,\r\n.em-flow-label-shadow {\r\n    font-size: 12px;\r\n    stroke-width: 2px;\r\n    stroke: white;\r\n    opacity: 0.9;\r\n    fill: none;\r\n}\r\n\r\n.em-label-background {\r\n    fill: #ffffff;\r\n    opacity: 0.9;\r\n}\r\n\r\n.em-stat-label {\r\n    fill: #111111;\r\n    stroke: #111111;\r\n    stroke-width: 0.5px;\r\n}\r\n\r\n.em-stat-label-shadow {\r\n    fill: none;\r\n    stroke: white;\r\n    stroke-width: 2.5px;\r\n    opacity: 0.9;\r\n}\r\n\r\n.em-stat-label,\r\n.em-stat-label-shadow {\r\n    font-size: 13px;\r\n}\r\n\r\n.em-label-cc {\r\n    font-size: 12px;\r\n}\r\n\r\n.em-label-shadow-cc {\r\n    font-size: 12px;\r\n    stroke-width: 3px;\r\n}\r\n\r\n.em-label-countries {\r\n    fill: #111111;\r\n    font-size: 10px;\r\n}\r\n\r\n.em-label-shadow-countries {\r\n    font-size: 10px;\r\n    stroke-width: 3px;\r\n}\r\n\r\n.em-label-seas {\r\n    font-size: 9px;\r\n    fill: #2a58b3;\r\n    letter-spacing: 0.25em;\r\n    opacity: 0.7;\r\n}\r\n\r\n.em-label-shadow-seas {\r\n    font-size: 9px;\r\n    letter-spacing: 0.25em;\r\n    stroke-width: 3px;\r\n    opacity: 0.5;\r\n}\r\n\r\n.em-flow-labels {\r\n    text-anchor: middle;\r\n    stroke-linejoin: round;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    dominant-baseline: central;\r\n}\r\n\r\n.em-flow-label {\r\n    font-size: 13px;\r\n    fill: #333333;\r\n    font-weight: bold;\r\n    opacity: 0.9;\r\n}\r\n\r\n.em-flow-label-shadow {\r\n    font-size: 13px;\r\n    stroke-width: 3px;\r\n}\r\n\r\n.em-circle-stat-label,\r\n.em-circle-stat-label-shadow {\r\n    text-anchor: middle;\r\n    stroke-linejoin: round;\r\n    stroke-linecap: round;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    dominant-baseline: central;\r\n    pointer-events: none;\r\n    paint-order: stroke fill;\r\n}\r\n\r\n.em-circle-code-label,\r\n.em-circle-code-label-shadow {\r\n    text-anchor: middle;\r\n    stroke-linejoin: round;\r\n    stroke-linecap: round;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    dominant-baseline: central;\r\n    pointer-events: none;\r\n    paint-order: stroke fill;\r\n}\r\n\r\n/* labels that overflow outside the proportional symbol */\r\n/* .em-stat-overflowing,\r\n.em-code-overflowing {\r\n    opacity: 0.75;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
